import {$insertDataTransferForPlainText} from '@lexical/clipboard';
import '@lexical/plain-text';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$getSelection, COMMAND_PRIORITY_CRITICAL, PASTE_COMMAND} from 'lexical';

import {useRef} from 'react';

import {useOnMount} from 'shared/web';

export const RawPastePlugin = () => {
  const [editor] = useLexicalComposerContext();
  const unregister = useRef<VoidFunction | null>(null);

  useOnMount(
    () => {
      unregister.current = editor.registerCommand<ClipboardEvent>(
        PASTE_COMMAND,
        (event) => {
          event.preventDefault();
          const selection = $getSelection();
          if (event.clipboardData && selection) {
            $insertDataTransferForPlainText(event.clipboardData, selection);
          }
          return true;
        },
        COMMAND_PRIORITY_CRITICAL
      );
    },
    () => unregister.current?.()
  );

  return null;
};
